export const SEARCH_URL = `https://api.mapbox.com/autofill/v1`;

export const ENDPOINT_SUGGEST = 'suggest';
export const ENDPOINT_RETRIEVE = 'retrieve';

export const SUGGEST_URL = `${SEARCH_URL}/${ENDPOINT_SUGGEST}`;
export const RETRIEVE_URL = `${SEARCH_URL}/${ENDPOINT_RETRIEVE}`;
